
import { Location} from '~commonInfra/utils/Location';
import {
  SessionSiteSelectors,
  SessionUserSelectors
} from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { SiteRolesUtil } from '~src/userManagement/services/resources/SiteRolesUtil';
import { UpdateDataManagementAwarenessRequest } from '~src/userSettings/serverApi/requests/UpdateDataManagementAwarenessRequest';

export function showDMAwareness() {
  const state = getAppStore().getState();
  const featureFlagEnabled = getSessionManagementServiceInstance().dMAwarenessEnabled();
  const isUserSettingEnabled = SessionUserSelectors.showCatalogAwareness(state);
  const isDataManagementEnabled = SessionSiteSelectors.isDataManagementEnabled(state);
  const role = SessionSiteSelectors.siteRole(state);
  const isExplorerOrCreator = SiteRolesUtil.isExplorer(role)|| SiteRolesUtil.isCreatorOrServerAdmin(role);

  return featureFlagEnabled
  && isUserSettingEnabled
  && !isDataManagementEnabled
  && isExplorerOrCreator;
}

export function sendDisableDMAwarenessRequest(user: string) {
  WebHttpClientWithErrorToastInstance.sendRequestAndDelay(
    new UpdateDataManagementAwarenessRequest({
        user:user,
        prepConductorAwarenessEnabled:SessionUserSelectors.showPrepConductorAwareness(getAppStore().getState()),
        catalogAwarenessEnabled: false
    })).then(() => getSessionManagementServiceInstance().refreshSessionInfo());
}

export function showDisableDataManagementAwarenessToast(url: string) {

  ToasterService.instance.pop({
    type: ToastType.Info,
    text: Messages.dataManagementAwarenessSettingToast(),
    actionMessage: Messages.flowSchedulesInformationalHideViewSettings(),
    action: () => { Location.instance.setUrl(url); }
  });
}